import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle15() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article15" headerImage="FrontPage.png" />
        <Footer />
    </div>
  )
}
